import { ENGINE_MATCHER_BOOLEAN } from '../../logger/constants';
export function booleanMatcherContext(log, ruleAttr) {
    return function booleanMatcher(runtimeAttr) {
        var booleanMatches = ruleAttr === runtimeAttr;
        log.debug(ENGINE_MATCHER_BOOLEAN, [ruleAttr, runtimeAttr]);
        return booleanMatches;
    };
}
